<template>
  <div
    id="map-with-info"
    :class="[
      'container-' + organism.containerWidth,
      organism.removeMargin,
      organism.hideInfo ? 'hide-info' : '',
      'bg-bc-gray organism map-with-info isolate',
    ]"
  >
    <header class="px-8 pt-14 pb-[69px] -mb-[25px]">
      <h2
        class="text-3xl sm:text-[44px] font-archer text-white font-semibold text-center m-0 leading-none"
      >
        {{ organism.title1 }}
      </h2>
    </header>
    <div class="relative pointer-events-none min-h-[600px]">
      <div
        id="map-wrap"
        class="absolute top-0 left-0 hidden w-full h-full sm:block -z-10 isolate"
      >
        <div id="map" class="w-full h-full pointer-events-auto"></div>
      </div>
      <div v-if="!organism.hideInfo" class="grid grid-cols-1 sm:grid-cols-2">
        <div
          class="bg-white p-8 max-w-[366px] mr-auto sm:mr-0 ml-auto my-8 sm:my-16 pointer-events-auto"
        >
          <div class="mb-4">
            <h3 class="text-lg font-bold font-arial">Address</h3>
            <NuxtLink
              :to="
                'https://www.google.com/maps/place/' +
                organism.latitude +
                ',' +
                organism.longitude
              "
              target="_blank"
              class="block underline text-bc-dark-blue"
            >
              <span>{{ organism.address1 }}<br /></span>
              <span v-if="organism.address2"
                >{{ organism.address2 }}<br
              /></span>
              <span v-else>
                <span v-if="organism.city">{{ organism.city }},&nbsp;</span
                ><span v-if="organism.state">{{ organism.state }}&nbsp;</span
                ><span v-if="organism.zip">{{ organism.zip }}</span>
              </span>
            </NuxtLink>
          </div>
          <div v-if="organism.hours" class="mb-4">
            <h3 class="text-lg font-bold font-arial">Hours</h3>
            <div v-html="organism.hours"></div>
          </div>
          <div v-if="organism.phone" class="mb-4">
            <h3 class="text-lg font-bold font-arial">Phone</h3>
            <NuxtLink
              :to="'tel:' + organism.phone"
              class="underline text-bc-dark-blue"
              >{{ organism.phone }}</NuxtLink
            >
          </div>
          <div v-if="organism.salesTeamMembers" class="mb-4">
            <h3 class="text-lg font-bold font-arial">Sales Team</h3>
            <ul
              class="flex flex-wrap items-center justify-center text-center gap-4"
            >
              <li v-for="member in organism.salesTeamMembers">
                <img
                  :src="getImageSrc(member.image, 'thumbnail')"
                  :alt="member.name"
                  class="w-[88px] aspect-square rounded-full mb-2"
                />
                <h4>{{ member.name }}</h4>
              </li>
            </ul>
          </div>
          <NuxtLink
            :to="
              'https://www.google.com/maps/place/' +
              organism.latitude +
              ',' +
              organism.longitude
            "
            target="_blank"
            class="block py-3 mb-4 font-semibold text-center text-white px-7 bg-bc-blue"
          >
            Get Directions
          </NuxtLink>
          <div class="text-[11px] text-gray-400">{{ organism.legal }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.map-with-info {
  header {
    background-image: linear-gradient(101deg, #367ea0 0%, #4dadce 97%);
    clip-path: polygon(
      0 0,
      100% 0,
      100% calc(100% - 25px),
      calc(50% - 25px) calc(100% - 25px),
      50% 100%,
      calc(50% + 25px) calc(100% - 25px),
      0 calc(100% - 25px)
    );
  }

  &.hide-info {
    #map-wrap {
      @apply !block;
    }
  }
}
</style>

<script setup>
import { storeToRefs } from "pinia";
const overview = useOverview();
const { mapInfo } = storeToRefs(overview);

const props = defineProps({
  organism: Object,
});

onMounted(() => {
  loadMapWithInfoMap();
  if (props.organism.containerWidth === "full-width") {
    addFullWidthSupport();
  }

  if (props.organism.mapWithInfoMapType === "all-neighborhoods") {
    loadNeighborhoodsMap();
  } else {
    updateMapWithInfoMap(
      props.organism.latitude,
      props.organism.longitude,
      props.organism.markerTitle
    );
  }
});

onUpdated(() => {
  if (props.organism.mapWithInfoMapType !== "all-neighborhoods") {
    updateMapWithInfoMap(
      props.organism.latitude,
      props.organism.longitude,
      props.organism.markerTitle
    );
  }
});

watch(mapInfo, () => {
  if (props.organism.mapWithInfoMapType === "all-neighborhoods") {
    const offsetX = props.organism.hideInfo ? 0 : 250;
    updateNeighborhoodsMap(mapInfo, offsetX);
  }
  // } else {
  //   updateNeighborhoodsMap(mapInfo, 250);
  // }
});
</script>
